import { render, staticRenderFns } from "./painel-secao-contexto.vue?vue&type=template&id=4f5f5ca4&scoped=true&"
import script from "./painel-secao-contexto.vue?vue&type=script&lang=js&"
export * from "./painel-secao-contexto.vue?vue&type=script&lang=js&"
import style0 from "./painel-secao-contexto.vue?vue&type=style&index=0&id=4f5f5ca4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f5ca4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f5f5ca4')) {
      api.createRecord('4f5f5ca4', component.options)
    } else {
      api.reload('4f5f5ca4', component.options)
    }
    module.hot.accept("./painel-secao-contexto.vue?vue&type=template&id=4f5f5ca4&scoped=true&", function () {
      api.rerender('4f5f5ca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/painel-do-chat/painel-secao-contexto.vue"
export default component.exports